<style lang="scss">
  .judge-post{
    b {
      display: block;
    }
  }
</style>

<!-- eslint-disable -->
<template>
  <b-card class="judge-post">
    <div class="row">
      <!-- Clinician -->
      <section class="col-12 d-flex" v-if="is_clinician">
        <b-button @click="showModal('modal-approve-warning')"
                  :class="{'disabled': loading}"
                  class="btn-success mr-1">Approve Post</b-button>
        <b-button @click="showModal('modal-reject-warning')"
                  :class="{'disabled': loading}"
                  class="btn-danger">Reject Post</b-button>
      </section>
      <!--  Non clinician with post not assigned to one    -->
      <section class="col-12 d-flex" v-if="!is_clinician && !post.clinician_assigned">
        <b-button @click="showModal('modal-approve-warning')"
                  :class="{'disabled': loading}"
                  class="btn-success mr-1">Approve Post</b-button>
        <b-button @click="showModal('modal-reject-warning')"
                  :class="{'disabled': loading}"
                  class="btn-danger">Reject Post</b-button>
        <b-button @click="showModal('modal-assign-clinician')"
                  :class="{'disabled': loading}"
                  class="btn ml-1">Assign for approval</b-button>
      </section>
      <!--  Non clinician with post assigned but still awaiting    -->
      <section v-if="!is_clinician && post.clinician_assigned" class="col-12 d-flex">
        <p>Post is awaiting confirmation from assigned staff member: <b>{{post.clinician_assigned.name}}</b></p>
      </section>
    </div>

    <b-modal id="modal-approve-warning" title="" hide-footer>
      <warning-modal title="Are you sure you wish to approve this post?"
                     :subtitle="(post.post_type === 'Digital' && post.firstPost) ? 'This is the first post between these two' : ''"
                     ok-variant="success"
                     @ok="approvePost()"
                     @close="closeAllModals()"/>
    </b-modal>

    <b-modal id="modal-reject-warning" title="" hide-footer>
      <warning-modal title="Are you sure you wish to reject this post?"
                     @ok="rejectPost()"
                     @close="closeAllModals()">
        <template slot="extra">
          <div class="text-left">
            <label>Enter rejection reason</label>
            <b-form-textarea rows="3" max-rows="6"
                             v-model="rejectionReason" class="mb-1" placeholder="'Enter rejection reason"/>
          </div>
        </template>
      </warning-modal>
    </b-modal>

    <b-modal id="modal-assign-clinician" title="" hide-footer>
      <assign-clinician @close="closeAllModals()" @refresh="refresh()" :post="post"></assign-clinician>
    </b-modal>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
  import { mapState } from 'vuex';
  import WarningModal from '../../../components/modals/WarningModal.vue';
  import PostService from '../../../services/PostService';
  import AssignClinician from './AssignClinician.vue';

  export default {
    components: {
      WarningModal,
      AssignClinician,
    },
    props: {
      post: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        loading: false,
        rejectionReason: '',
      };
    },
    computed: {
      ...mapState({
        is_clinician: state => state.auth.user.is_clinician,
      }),
    },
    mounted() {},
    methods: {
      closeAllModals() {
        this.$bvModal.hide('modal-approve-warning');
        this.$bvModal.hide('modal-reject-warning');
        this.$bvModal.hide('modal-assign-clinician');
      },
      showModal(modalName) {
        this.$bvModal.show(modalName);
      },
      viewPdf(url) {
        window.open(url);
      },
      fetchPrintQueue() {
        console.log('fetch print queue');
      },
      emitRefresh() {
        this.$emit('refresh', true);
      },
      approvePost() {
        this.loading = true;
        // eslint-disable-next-line no-underscore-dangle
        PostService.approvePost(this.post._id).then(() => {
          this.$toast.success('Approved post Successfully', {
            toastClassName: ['toast-std', 'success-toast'],
          });

          this.emitRefresh();
        }).catch(err => {
          console.log('could not approve post', err);
          this.$toast.error('Could not approve post, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          this.loading = false;
        });
      },
      rejectPost() {
        this.loading = true;
        // eslint-disable-next-line no-underscore-dangle
        PostService.rejectPost(this.post._id, this.rejectionReason).then(() => {
          this.$toast.success('Rejected post Successfully', {
            toastClassName: ['toast-std', 'success-toast'],
          });

          this.emitRefresh();
        }).catch(err => {
          console.log('could not reject post', err);
          this.$toast.error('Could not reject post, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          this.loading = false;
        });
      },
      refresh() {
        this.closeAllModals();
        this.emitRefresh();
      },
    },
  };
</script>
